<!--{{ALLAPPS | json}}
<hr>
{{APPS | json}}
{{edit}} -->
<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }}</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="companyForm">
    <div class="my-4 table-editor_input-wrapper">
      <mdb-form-control>
        <input
          mdbInput
          type="text"
          id="company-input"
          class="form-control"
          formControlName="company"
          required
          minlength="5"
          
        />
        <label mdbLabel class="form-label" for="company-input">Empresa (mínimo 5 caracteres) </label>
      </mdb-form-control>
      <div *ngIf="companyForm?.get('company')?.errors?.['minlength']">
      </div>
    </div>
    <div class="my-4 table-editor_input-wrapper">
      <div class="form-check ms-1 mt-1">
        <input
          mdbCheckbox
          class="form-check-input"
          type="checkbox"
          value=""
          id="active-checkbox"
          formControlName="active"
          (change)="onCheckboxChange($event)"
        />
        <label class="form-check-label" for="flexCheckDefault">
            Empresa Activa
        </label>
      </div>
    </div>
    <div class="my-4 table-editor_input-wrapper">
      <div class="col-md-6">
        <mdb-file-upload
          #fileUpload
          [defaultPreview]="logo ? logo : null"
          [removeBtn] ="'Eliminar'"
          [defaultMsg]="'Seleccione Logo'" 
          [previewMsg]="'Arrastre o haga click para seleccionar otro archivo'"
          [removeBtnDisabled]="true"
          (fileAdded)="onFileAdded($event)">
        </mdb-file-upload>
      </div>
    </div>

    <div class="form-check" *ngIf="edit == 0">
      <input
        mdbCheckbox
        class="form-check-input"
        type="checkbox"
        value=""
        id="flexCheckDefault"
        (change)="AssociateAppChange($event)"
      />
      <label class="form-check-label" for="flexCheckDefault" >
        Desea Asociar una APP  a esta compañia ?
      </label>
    </div>
    
    <div *ngIf="AssociateApp || edit == 1" >
       {{ APPS?.length > 0 ? 'Apps Asociadas:' : '' }} 
      <mdb-form-control>
        <mdb-select [multiple]="true" formControlName="selectedApps">
          <mdb-select-all-option>Select all</mdb-select-all-option>
          <mdb-option *ngFor="let option of ALLAPPS" [value]="option.value">{{
            option.label
          }}</mdb-option>
        </mdb-select>
        <label mdbLabel class="form-label">Selecione App(s)</label>
      </mdb-form-control>
    </div>

  </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="shadow-0 btn btn-md btn-outline-primary"
      (click)="modalRef.close()"
    >
      Cancelar
    </button>

    <button 
      type="button"
      class="shadow-0 btn btn-md btn-primary"
      (click)="InsertOrUpdate()"
      [textContent]="edit === 0 ? 'Guardar' : 'Editar'"
      [disabled]="companyForm.invalid"
      >
    </button>
  </div>

  <mdb-loading [show]="loading" [fullscreen]="true">
    <div class="loading-spinner">
      <div class="spinner-border loading-icon" role="status"></div>
      <span class="loading-text">Cargando datos...</span>
    </div>
  </mdb-loading>
